import { Box, Typography } from "@mui/material"
import { User } from "graphql/types"
import { formatDateTime } from "utils/dateTimeUtils"

type PersonTitleBoxProps = {
  createdAt: string
  person?: User
}

export const PersonTitleBox = (props: PersonTitleBoxProps) => {
  const { createdAt, person } = props

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Typography variant="caption">{formatDateTime(createdAt)}</Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Typography variant="caption">{`${person?.displayName || "N/A"}`}</Typography>
      </Box>
    </Box>
  )
}
